import { render } from "./UnusableChoicesValidationsTable.vue?vue&type=template&id=1ebad846&scoped=true"
import script from "./UnusableChoicesValidationsTable.vue?vue&type=script&lang=js"
export * from "./UnusableChoicesValidationsTable.vue?vue&type=script&lang=js"

import "./UnusableChoicesValidationsTable.vue?vue&type=style&index=0&id=1ebad846&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebad846"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
